import { PlayerStatus } from '@vbrick/rev-sdk';
export { PlayerStatus } from '@vbrick/rev-sdk';

// magic keyword to specify subtitles are using "Closed Captions" instead of subtitle file with language
export const SDK_CC_LANG_SPECIFIER = 'captions';

/**
 * messages passed to SDK Embed and their expected shape
 */
export type TSDKPlayerMessage =
	['videoLoaded', ISDKVideoInfo] |
	['playerStatusChanged', { status: PlayerStatus; }] |
	['volumeChanged', number] |
	['subtitlesChanged', ISDKSubtitlesEvent] |
	['playbackSpeedChanged', number] |
	['seeked', { startTime: number, endTime: number; }] |
	['currentTime', { currentTime: number, duration: number; }] |
	['recordingComplete', string];

/**
 * methods exposed by SDK Embed and their incoming payload
 */
export type SDKPlayerMethod =
	['playVideo'] |
	['pauseVideo'] |
	['setPlaybackSpeed', { speed: number; }] |
	['setVolume', { volume: number; }] |
	['setSubtitles', ISDKSubtitlesEvent] |
	['seek', { currentTime: number; }];

export interface ISDKSubtitlesEvent {
	language?: string;
	enabled: boolean;
}

export interface ISDKVideoInfo {
	videoId: string;
	title: string;
	status: string;
	duration: number;
	isLive: boolean;
	is360: boolean;
	hasAudioOnly: boolean;
	subtitles: Array<{ language: string; }>;
	chapters: Array<{
		time: number;
		imageId?: string;
		extension?: string;
		title?: string;
	}>;
	playbacks: Array<{
		id: string;
		label: string;
		streamDeliveryType: string;
		zoneName?: string;
		deviceName?: string;
	}>;
}
